module.exports = __webpack_public_path__ + "static/img/copy_icon.681ad66d.png";